export enum CodexDeviceAuthStatusEnum {
  Pending = 'Pending',
  Authorized = 'Authorized',
  Failed = 'Failed'
}
